/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportCatalogSubCategory {
    getFixupPrototypeFunction() { return ReportCatalogSubCategory.fixupPrototype; }

    static newInstance(model: Partial<ReportCatalogSubCategory>): ReportCatalogSubCategory {
        let obj = Object.assign(new ReportCatalogSubCategory(), model);
        ReportCatalogSubCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportCatalogSubCategory>): ReportCatalogSubCategory {
        if (!model) return null;
        return ReportCatalogSubCategory.newInstance(<ReportCatalogSubCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportCatalogSubCategory) {
        if (!obj) return;

        models.ReportCatalogSubCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportCatalogSubCategory): boolean {
        Object.setPrototypeOf(obj, ReportCatalogSubCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.report_count === undefined) {
            this.report_count = 0;
        }
        if (this.reports) {
            for (let val of this.reports) {
                models.ReportCatalogItem.fixupPrototype(val);
            }
        }
    }

    /**
     * Sub-category key, e.g. cost_reports
     */
    name: string;

    /**
     * Number of reports in the sub-category
     */
    report_count: number;

    /**
     * Information about the sub-category, taken from its first report
     */
    info: string;

    /**
     * Reports in the sub-category, sorted by name
     */
    reports: Array<models.ReportCatalogItem>;

}
